import { ChangeEvent } from "react";

import { PeopleBlockStatus } from "Bands/types";
import { peopleBlockStatuses } from "Bands/utils";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { errors } = copy;
const peopleBlockCopy = copy.peopleBlock.editStatus;

const getOptions = (currentStatus?: PeopleBlockStatus) => {
  if (currentStatus === PeopleBlockStatus.rsvp) {
    return peopleBlockStatuses.map(({ label, value }) => {
      if (value === PeopleBlockStatus.rsvp) {
        return { label: peopleBlockCopy.actions.resendRSVP, value };
      }

      return {
        label: `${
          peopleBlockCopy.actions.cancelRSVP
        } and ${peopleBlockCopy.actions.setTo.toLowerCase()} "${label}"`,
        value,
      };
    });
  }

  return peopleBlockStatuses
    .filter(
      ({ value }) => value !== currentStatus && value !== PeopleBlockStatus.none
    )
    .map(({ label, value }) => {
      if (value === PeopleBlockStatus.rsvp) {
        return { label, value };
      }

      return {
        label: `${peopleBlockCopy.actions.setTo} "${label}"`,
        value,
      };
    });
};

export const getFields = ({
  currentStatus,
  onStatusChange,
}: {
  currentStatus?: PeopleBlockStatus;
  onStatusChange?: (status: PeopleBlockStatus) => void;
}): IFormFields => [
  {
    type: IFieldType.radioGroup,
    name: "status",
    label: peopleBlockCopy.title,
    hideLabel: true,
    validation: {
      required: errors.required,
    },
    options: getOptions(currentStatus),
    isInline: false,
    onChange: (value: ChangeEvent<HTMLInputElement>) =>
      onStatusChange && onStatusChange(value.target.value as PeopleBlockStatus),
  },
];
